import { render, staticRenderFns } from "./VerifyStep4.vue?vue&type=template&id=6ca9bfc8&"
import script from "./VerifyStep4.vue?vue&type=script&lang=js&"
export * from "./VerifyStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports